<template>
  <div v-show="photo.display" class="upload-img-item" :class="textClass">
    <div class="grid-x">
      <div class="cell shrink">
        <div class="img-wrap">
          <div class="active-cover">
            <span>Annonsbild</span>
          </div>
          <div class="img-overlay">
            <div class="move-handle" style="
    width: 35px;
    height: 35px;
    float: left;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0px 5px 0px 0px;
    background-clip: padding-box;
    cursor: pointer;
    display: grid;
    color: white;
">
              <!-- <img src="/img/arrows-alt-v-solid.svg" alt="Grip" /> -->

              <svg style="justify-self: center;
    align-self: center;width:20px;height:22px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrows-alt-v" class="svg-inline--fa fa-arrows-alt-v fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="#ffffff" d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z" /></svg>
            </div>

            <div class="img-delete" @click.prevent="deletePhoto">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22">
                <path
                  fill-rule="evenodd"
                  d="M14.460911 3.2500376h3.609366c.273437 0 .505858.0957026.697264.2871086.191406.191406.287109.4238269.287109.697264v.0820311c0 .0546871-.027344.1093749-.082031.1640621-.054687.0546871-.109375.082031-.164062.082031h-1.066404v15.093714c0 .5468735-.191406 1.0117166-.574217 1.394528-.382812.3828113-.847655.5742173-1.394528.5742173H3.960936c-.546874 0-1.011717-.191406-1.394528-.5742173-.382811-.3828114-.574217-.8476545-.574217-1.394528V4.5625344H.925787c-.054687 0-.109375-.0273439-.164062-.082031-.054687-.0546872-.082031-.109375-.082031-.1640621v-.0820311c0-.2734371.095702-.505858.287108-.697264.191406-.191406.423827-.2871086.697264-.2871086h3.609367l1.394528-1.8456988c.382811-.5195302.902341-.779295 1.55859-.779295h3.281242c.656248 0 1.175778.2597648 1.55859.779295l1.394528 1.8456988zm-6.23436-1.3124969c-.21875 0-.396484.082031-.533202.2460931l-.779295 1.0664038h5.906236l-.779295-1.0664038c-.136719-.1640621-.314453-.2460931-.533202-.2460931H8.226551zm8.203105 17.7187077V4.5625344H3.304687v15.093714c0 .191406.061524.348632.18457.4716786.123047.1230466.280273.1845699.471679.1845699h11.812472c.191406 0 .348632-.0615233.471678-.1845699.123047-.1230466.18457-.2802726.18457-.4716786zM9.210923 7.0234661c0-.1367183.047852-.2529293.143555-.348632.095702-.0957027.211913-.1435544.348632-.1435544h.328124c.136718 0 .252929.0478517.348632.1435544.095703.0957027.143554.2119137.143554.348632v10.8280991c0 .1367183-.047851.2529293-.143554.348632-.095703.0957027-.211914.1435544-.348632.1435544H9.70311c-.136719 0-.25293-.0478517-.348632-.1435544-.095703-.0957027-.143555-.2119137-.143555-.348632V7.0234661zm-3.281242 0c0-.1367183.047852-.2529293.143554-.348632.095703-.0957027.211914-.1435544.348632-.1435544h.328125c.136718 0 .252929.0478517.348632.1435544.095702.0957027.143554.2119137.143554.348632v10.8280991c0 .1367183-.047852.2529293-.143554.348632-.095703.0957027-.211914.1435544-.348632.1435544h-.328125c-.136718 0-.252929-.0478517-.348632-.1435544-.095702-.0957027-.143554-.2119137-.143554-.348632V7.0234661zm6.562484 0c0-.1367183.047852-.2529293.143555-.348632.095703-.0957027.211914-.1435544.348632-.1435544h.328124c.136718 0 .252929.0478517.348632.1435544.095703.0957027.143554.2119137.143554.348632v10.8280991c0 .1367183-.047851.2529293-.143554.348632-.095703.0957027-.211914.1435544-.348632.1435544h-.328124c-.136718 0-.252929-.0478517-.348632-.1435544-.095703-.0957027-.143555-.2119137-.143555-.348632V7.0234661z" />
              </svg>
            </div>
          </div>
          <img
            :src="url"
            :style="{ transform: photo.style }"
            @error="photo.display = false">
        </div>
      </div>
      <div class="cell auto">
        <div class="img-detail-wrap">
          <form @submit.prevent="updateForm">
            <FloatLabel :dispatch="false" style="margin-bottom:15px;">
              <select v-model.number="photo.room" class="small" :style="selectColor(photo.room)">
                <option value="0" selected disabled>
                  Vilket rum visar bilden?
                </option>
                <option
                  v-for="what in photoRoom"
                  :key="what.id"
                  :value="what.id">
                  {{ what.name }}
                </option>
              </select>
            </FloatLabel>
            <FloatLabel>
              <input
                v-model="photo.description"
                type="text"
                class="small"
                maxlength="80"
                placeholder="Bildbeskrivning"
                @keydown="savePhoto">
            </FloatLabel>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--
  <div v-show="photo.display" class="grid-x" :class="textClass">
    <div class="cell small-4">
      <img
        :src="url"
        :style="{ transform: photo.style }"
        @error="photo.display = false"
      />
    </div>
    <div class="cell small-8">
      <form @submit.prevent="updateForm">
        <div class="cell small-12">
          <label
            >Bildtext
            <input v-model="photo.description" @keydown="savePhoto" />
          </label>
        </div>

        <div class="cell small-12">
          <label
            >Vad föreställer bilden?
            <select v-model.number="photo.room">
              <option value="0" disabled>Vad föreställer bilden?</option>
              <option
                v-for="what in photoRoom"
                :key="what.id"
                :value="what.id"
                >{{ what.name }}</option
              >
            </select>
          </label>
        </div>

        <div class="cell small-12">
          <button class="button" @click.prevent="deletePhoto">
            Radera bilden
          </button>
        </div>
      </form>
    </div>
  </div> -->
</template>

<script>
import AdService from '@/services/AdService.js'
import FloatLabel from '@/components/FloatLabels.vue'
// import _ from 'loadash'

export const photoRoom = {
  // 0: { name: 'Vad föreställer bilden?', slug: 'photo.what' },
  1: { id: 1, name: 'Sovrum', slug: 'photo.bedroom' },
  2: { id: 2, name: 'Vardagsrum', slug: 'photo.livingroom' },
  3: { id: 3, name: 'Kök', slug: 'photo.kitchen' },
  4: { id: 4, name: 'Hall', slug: 'photo.hallway' },
  5: { id: 5, name: 'Badrum', slug: 'photo.bathroom' },
  6: { id: 6, name: 'Toalett', slug: 'photo.toilet' },
  7: { id: 7, name: 'Förråd', slug: 'photo.storage' },
  8: { id: 8, name: 'Balkong', slug: 'photo.balcony' },
  9: { id: 9, name: 'Terrass', slug: 'photo.terrace' },
  10: { id: 10, name: 'Vind', slug: 'photo.attic' },
  11: { id: 11, name: 'Trappuppgång', slug: 'photo.entrance' },
  12: { id: 12, name: 'Uteplats', slug: 'photo.patio' },
  13: { id: 13, name: 'Ritning/Planlösning', slug: 'photo.blueprint' }
}

export default {
  components: {
    FloatLabel
  },
  props: {
    photo: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      updating: false,
      textClass: ''
    }
  },
  computed: {
    url () {
      return this.baseUrl
    },
    baseUrl () {
      let provider = this.photo.provider
      let base_url = ''
      if (provider == 's3') {
        base_url = 'https://s3.eu-west-1.amazonaws.com/bytbostad.info/square/' + this.photo.img_url
      } else if (provider == 'local') {
        base_url = 'https://bytbostad.se/slir/w400/upload/' + this.photo.img_url
      } else {
        base_url = this.photo.img_url
      }
      return base_url
    },
    photoRoom () {
      return _.orderBy(photoRoom, [c => c.name], ['asc'])
    }
  },
  watch: {
    photo: {
      handler () {
        this.updateForm()
      },
      deep: true
    }
  },

  methods: {
    selectColor (val) {
      if (!Number.isInteger(val) || !val) {
        return 'color:var(--main-bg-color)'
      }
    },
    saveForm () {
      let photo = { ...this.photo }
      delete photo.img_url
      delete photo.display

      AdService.editPhoto(photo.id, photo)
        // .then((response) => {
        //   // console.log(response)
        // })
        .catch(error => {
          Sentry.captureException(error);
          this.errors = error
        })
    },
    updateForm () {
      this.savePhoto()
    },
    deletePhoto () {
      this.$emit('delete')
    },
    makePrimary () {
      this.$emit('primary')
    },
    savePhoto () {
      let _this = this
      _this.textClass = 'updating'

      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        _this.textClass = 'done'
        setTimeout(() => {
          _this.textClass = ''
        }, 1500)
        this.saveForm()
      }, 300)
    }
  }
}
</script>

<style scoped>
/* .updating {
  background-color: orange;
}
.done {
  background-color: green;
}
.button {
  cursor: pointer;
} */
</style>
